import { logging, utils } from "@heimdall/core-common";
var logger = logging.instantiateLogger("heimdall:core:domain:network:codec");
import { Contact } from "./models";
export var ContactCodec = utils.CodecUtils.generateCodec(logger)(Contact)(Contact.is);